import './LoginPage.css'
import { BP_BRANDING_VERSION, BP_LOGO_DARK, BP_LOGO_ALT } from './lib/branding/brand'

// BotPros authenticates via Cloudflare Access → Google SSO only (the inherited
// Microsoft/Entra option was removed). The single button hands off to the CF
// Access flow at /auth/trigger, which presents Google.
const GOOGLE_LOGO = (
  <svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.5 0 10.5-2.1 14.3-5.6l-6.6-5.6C29.6 34.6 26.9 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.6 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.6 5.6C41.6 35.9 44 30.5 44 24c0-1.3-.1-2.3-.4-3.5z" />
  </svg>
)

export function LoginPage({ errorMessage }: { errorMessage?: string | null } = {}) {
  const signIn = () => {
    const dest = (window.location.pathname + window.location.hash) || '/'
    window.location.href = `/auth/trigger?redirect_url=${encodeURIComponent(dest)}`
  }
  return (
    <div className="login-root" data-branding={BP_BRANDING_VERSION} data-marker="bp-login-station-v1">
      <div className="login-content">
        <img src={BP_LOGO_DARK} alt={BP_LOGO_ALT} className="login-logo" data-marker={BP_BRANDING_VERSION} />
        {errorMessage && (
          <div style={{
            maxWidth: 420,
            margin: '16px auto 0',
            padding: '12px 16px',
            borderRadius: 8,
            background: 'rgba(220,38,38,0.12)',
            border: '1px solid rgba(220,38,38,0.35)',
            color: '#fca5a5',
            fontSize: 14,
            lineHeight: 1.5,
            textAlign: 'center',
          }}>
            {errorMessage}
          </div>
        )}
        <button type="button" onClick={signIn} className="login-btn">
          {GOOGLE_LOGO}
          <span>Enter the station</span>
        </button>
      </div>
    </div>
  )
}
